import {ChangeEventHandler, FunctionComponent, KeyboardEventHandler, useState} from "react";
import {TextField} from "@mui/material";
import {FilledTextFieldProps, OutlinedTextFieldProps, StandardTextFieldProps} from "@mui/material/TextField/TextField";

interface IStandardTextFieldAuto extends StandardTextFieldProps {
    onCommit?: (value: unknown) => void
}
interface IFilledTextFieldAuto extends  FilledTextFieldProps {
    onCommit?: (value: unknown) => void
}
interface IOutlinedTextFieldAuto extends  OutlinedTextFieldProps {
    onCommit?: (value: unknown) => void
}
type ITextFieldAuto = IStandardTextFieldAuto | IFilledTextFieldAuto | IOutlinedTextFieldAuto
export const TextFieldAuto: FunctionComponent<ITextFieldAuto> = (props: ITextFieldAuto) => {
    const [working, setWorking] = useState(props.value);
    const commit = () => working !== props.value && props.onCommit && props.onCommit(working);
    const handleBlur = () => {
        commit();
    };
    const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
        setWorking(event.target.value);
        props.onChange && props.onChange(event);
    };
    const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = ({key, target}) => {
        if (key === "Enter") {
            if (target instanceof HTMLInputElement) {
                const form = target.closest("form");

                if (form) {
                    const fields = Array.from(form.elements) || [];
                    const enabled = fields.map(element => element as HTMLElement)
                        .filter(element => element instanceof HTMLInputElement);
                    const current = enabled.indexOf(target);
                    const nextTab = (current + 1) % enabled.length;

                    enabled[nextTab].focus();
                }
            }
            commit();
        }
    };
    const textFieldProps = {...props}

    delete textFieldProps.onCommit
    return (
        <TextField {...textFieldProps} value={working} onBlur={handleBlur} onChange={handleChange} onKeyDown={handleKeyDown}>
            {props.children}
        </TextField>
    );
}